module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\" id=\"modal-title\">\n    {{ 'schedule_help_out_title'|tr }}\n  </h3>\n</div> \n<div class=\"modal-body\" id=\"modal-body\">\n  <p>\n    {{ 'schedule_help_out_instruction'|tr }}\n  </p>\n</div>\n<div class=\"modal-footer\">\n  <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.ok()\">{{ 'global_yes'|tr }}</button>\n  <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.cancel()\">{{ 'global_no'|tr }}</button>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/schedule/helpOut.html
// module id = 240
// module chunks = 0